import { ReactNode } from 'react';
import { Trash2 } from 'react-feather';
import { useSelector } from 'react-redux';
import { RootState } from '../store/store';
import { updateCurrentUserInfo } from '../services/auth';
import { enqueueSnackbar } from 'notistack';
import { WIDGET_KEYS } from '../types/Widgets';

interface WidgetProps {
  widgetKey: WIDGET_KEYS;
  name: string;
  title: string;
  subtitle?: string;
  children: ReactNode;
  showDelete?: boolean;
}

const Widget: React.FC<WidgetProps> = ({
  widgetKey,
  name,
  title,
  subtitle,
  children,
  showDelete = false,
}) => {
  const customLayout = useSelector(
    (state: RootState) => state.user.profile?.homeLayout
  );

  const handleRemoveWidget = async (
    customLayout: WIDGET_KEYS[] | undefined
  ) => {
    if (!customLayout) return;
    try {
      await updateCurrentUserInfo({
        homeLayout: customLayout.filter((widget) => widget !== widgetKey),
      });
    } catch (error) {
      enqueueSnackbar('Failed to remove widget. Please try again.', {
        autoHideDuration: 3000,
      });
    }
  };

  return (
    <div className={`widget widget--${name}`}>
      <div className="widget_header">
        <h2>{title}</h2>
        {subtitle && <p className="subtitle">{subtitle}</p>}
        {showDelete && (
          <button
            className="button button--icon-only button--remove-widget"
            onClick={() => handleRemoveWidget(customLayout)}
            tabIndex={0}
            aria-label={`${title} Widget Menu`}
          >
            <Trash2 />
          </button>
        )}
      </div>
      <div className="widget_body">{children}</div>
    </div>
  );
};

export default Widget;
